const DoorData = [
    {
        imgSrc: 'card1',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
    {
        imgSrc: 'card2',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
    {
        imgSrc: 'card3',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
    {
        imgSrc: 'card4',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
    {
        imgSrc: 'card5',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
    {
        imgSrc: 'card6',
        title: 'Card Title #0',
        link: 'https://opensea.io/',
    },
]

export default DoorData;